import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// Actions.
import Actions from '../../actions';

// Selectors
import Selectors from '../../selectors';
import VotingSelectors from '../../../common/Voting/selectors';

import { Column } from './SocialContentWall';

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
/**
 * <pre>
 * Display Item > ContentVoting.
 *
 * Summary of responsibilities:
 *  - represents UgcWall content items as social wall <Column>
 *  - applies voting capabilities and post vote actions to content items
 * </pre>
 *
 * @memberOf UgcWall.Components.Modules
 * @namespace
 *
 * @return {UgcWall.Components.Modules.ContentVoting}
 */
class ContentVoting extends React.Component {
  /**
   * Constructor.
   *
   * @param {object} props The injected props
   */
  constructor(props) {
    super(props);

    this.handleVoteSuccess = this.handleVoteSuccess.bind(this);

    this.state = {
      fetchPending: false,
    };
  }

  componentDidUpdate() {
    // Overlays are attached to the current content in the DOM. Thus, we need
    // to postpone fetching of new content until overlays are closed.
    const { showRecaptcha, showCta, activeItem } = this.props;
    if (this.state.fetchPending && !activeItem.id && !showCta && !showRecaptcha) {
      this.props.fetchNext();
      this.setState({ fetchPending: false });
    }
  }

  componentDidMount() {
    // Listen for vote success event
    const eventService = NGXD.getServiceContainer().getService('event');
    eventService.listen('vote:success', this.handleVoteSuccess);
  }

  componentWillUnmount() {
    const eventService = NGXD.getServiceContainer().getService('event');
    eventService.unlisten('vote:success', this.handleVoteSuccess);
  }

  /**
   * Render the component.
   *
   * @return {module:UgcWall.Components.Modules.ContentVoting}
   */
  render() {
    return <Column className={this.props.className}>{this.props.children}</Column>;
  }

  /**
   * Callback handler for successful vote
   */
  handleVoteSuccess() {
    this.setState({ fetchPending: true });
  }
}

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {String} className List of css classnames to apply to the containing element.
 */

ContentVoting.propTypes = {
  className: PropTypes.string,
};

ContentVoting.defaultProps = {
  className: 'xContainer',
};

export default connect(
  (state, props) => ({
    activeItem:    Selectors.getActiveItem(state, props.moduleOpts.type, props.moduleId),
    showRecaptcha: VotingSelectors.getShowDynRecaptcha(state),
    showCta:       VotingSelectors.getShowPostVoteCTA(state),
  }),
  (dispatch, props) => ({
    fetchNext() {
      dispatch(
        Actions.pageItems(
          props.moduleId,
          props.moduleOpts.type,
          props.phase,
          props.moduleOpts.showMoreMode,
          props.moduleOpts.scope,
          props.moduleOpts.displayStrategy,
          undefined,
          'next',
          props.moduleOpts.shouldShowStickyContent,
          props.moduleOpts.shouldAutoPoll
        )
      );
    },
  })
)(ContentVoting);
